import { Flex, Text } from "@chakra-ui/react";
import { InfoCardData } from "../utils";

export const InfoCard = ({ icon, text }: InfoCardData) => {
  return (
    <Flex justify={"center"} alignItems={"center"} gap={3}>
      {icon && (
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          backgroundColor={"shades.white"}
          w={8}
          h={8}
          borderRadius={"50%"}
        >
          {icon}
        </Flex>
      )}
      <Text
        fontSize={"12px"}
        textAlign={"center"}
        fontWeight={500}
        lineHeight={"19.2px"}
      >
        {text}
      </Text>
    </Flex>
  );
};
